import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QualityBasedRoutingApiService {

  private readonly qualityBasedRoutingUrl: string = 'configuration/quality';

  constructor(private http: HttpClient) {}

  public getQualityBasedRoutingSettings(): Observable<any> {
    return this.http.get(this.qualityBasedRoutingUrl);
  }

  public editQualityBasedRoutingSettings(qualityBasedRoutingSettings): Observable<any> {
    return this.http.put(this.qualityBasedRoutingUrl, qualityBasedRoutingSettings);
  }
}
